<div class="col-sm-12 form-group p-2">
    <label for="companies">{{"clients.companyName" | translate}}</label>
    <select type="text" class="form-select" (change)="selectedCompany.emit($event)" id="companies">
        <option value=""></option>
        <option [value]="item.id" *ngFor="let item of companies">{{item.name}}</option>
    </select>
   </div>